import JSON_HEADERS from 'jsonHeaders'

class ClickTracking {
  constructor($el) {
    this.$el = $el
    this.trackVacancyClick = this.trackVacancyClick.bind(this)
    this.$button = this.$el.find('button')

    this.$button.on('click', this.trackVacancyClick)
  }

  get slug() {
    return this.$el.attr('data-slug')
  }

  trackVacancyClick() {
    fetch('/api/burosfera/vacancy_clicks/', {
      headers: JSON_HEADERS,
      method: 'POST',
      body: JSON.stringify({ slug: this.slug }),
    }).catch(e => console.error(e)) // eslint-disable-line no-console
  }
}

$('.js__clickTracking').each(function() {
  new ClickTracking($(this))
})
